import React from 'react';
import './Footer.css';

const Footer = ({ language }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          {language === 'ar'
            ? '© 2024 منظمة الخلد للإعمار والتنمية. جميع الحقوق محفوظة.'
            : '© 2024 Alkhold Organization for Development. All rights reserved.'}
        </p>
        <p>
          {language === 'ar' ? 'للتواصل: ' : 'Contact: '}
          <a href="mailto:alkhold.org2014@gmail.com">alkhold.org2014@gmail.com</a>
        </p>
        <p>
          {language === 'ar' ? 'الهاتف: ' : 'Phone: '}+249 123017742 | +249 963174603
        </p>
      </div>
    </footer>
  );
};

export default Footer; // تأكد من وجود هذا السطر
